import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    searchMeta: null,
    filters: [],
    tillClosureList: [],
    tillSummaryList: [],
    lastQuery: null,
    outletId: null,
    since: null,
    until: null,
};

const getters = {
    filters(state) {
        return state.filters;
    },
};

const mutations = {
    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    setFilters(state, filters) {
        state.filters = filters;
    },

    setTillClosureList(state, data) {
        state.tillClosureList = data;
    },

    setTillSummaryList(state, data) {
        state.tillSummaryList = data;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },

    setOutletId(state, data) {
        state.outletId = data;
    },

    setSince(state, data) {
        state.since = data;
    },

    setUntil(state, data) {
        state.until = data;
    },
};

const actions = {
    getSearchMeta({ commit, dispatch }, till_columns = {}) {
        const route = Laroute.route('franchise.report.till.search.meta');

        startLoading(dispatch, 'get-tillmeta');

        return axios
            .get(route, { params: till_columns })
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-tillmeta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-tillmeta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },

    getTillClosureListIfNecessary({ commit, dispatch, state }, params = {}) {
        if (
            params.outlet_id != state.outletId ||
            params.since != state.since ||
            params.until != state.until ||
            !state.tillClosureList.length ||
            state.lastQuery != params.query
        ) {
            commit('setOutletId', params.outlet_id);
            commit('setSince', params.since);
            commit('setUntil', params.until);

            return dispatch('getTillClosureList', params);
        }

        return Promise.resolve(state.tillClosureList);
    },

    getTillClosureList({ commit, dispatch }, params) {
        const route = Laroute.route('franchise.report.till.closure');

        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-till-closure');

        return axios
            .get(route, options)
            .then(res => {
                let data = res.data;

                commit('setTillClosureList', data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-till-closure');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-till-closure');
                throw err;
            });
    },

    getTillSummaryListIfNecessary({ commit, dispatch }, params = {}) {
        if (
            params.outlet_id != state.outletId ||
            params.since != state.since ||
            params.until != state.until ||
            !state.tillSummaryList.length ||
            state.lastQuery != params.query
        ) {
            commit('setOutletId', params.outlet_id);
            commit('setSince', params.since);
            commit('setUntil', params.until);

            return dispatch('getTillSummaryList', params);
        }

        return Promise.resolve(state.tillSummaryList);
    },

    getTillSummaryList({ commit, dispatch }, params) {
        const route = Laroute.route('franchise.report.till.summary');

        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-till-summary');

        return axios
            .get(route, options)
            .then(res => {
                let data = res.data;

                commit('setTillSummaryList', data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-till-summary');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-till-summary');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/till-filter.js